import { Injectable } from '@angular/core';
import { RiskModuleConfig } from '../agility-risk.config.interface';
import { DatePipe } from '@angular/common';
import { defaultDateFormat, defaultDateTimeFormat } from '../agility-risk.constants';

export class DateTimeServiceConfig {
  dateTimeFormat?: string;
  dateFormat: string;
}

@Injectable({
  providedIn: 'root'
})

export class AgilityRiskDateTimeService {
  private datetimeConfig: DateTimeServiceConfig;

  constructor(private config: DateTimeServiceConfig,
              private datePipe: DatePipe) {
    this.datetimeConfig = config;
  }

  get datetimeFormat(): string {
    return this.datetimeConfig?.dateTimeFormat || defaultDateTimeFormat;
  }

  get dateFormat(): string {
    return this.datetimeConfig?.dateFormat || defaultDateFormat;
  }

  formatDateTime(date: Date | string, datetimeFormat?: string): string {
    return this.datePipe.transform(date, datetimeFormat || this.datetimeFormat);
  }

  formatDate(date: Date | string, dateFormat?: string): string {
    return this.datePipe.transform(date, dateFormat || this.dateFormat);
  }
}

export function provideDateTimeServiceConfig(riskModuleConfig?: RiskModuleConfig): DateTimeServiceConfig {
  const datetimeServiceConfig = new DateTimeServiceConfig();

  if (riskModuleConfig) {
    datetimeServiceConfig.dateTimeFormat = riskModuleConfig?.dateTimeFormat || defaultDateTimeFormat;
    datetimeServiceConfig.dateFormat = riskModuleConfig?.dateFormat || defaultDateFormat;
  }

  return (datetimeServiceConfig);
}

